import React from "react";

import { NotificationBanner } from "@src/components/notification_banner";
import { useGetRoleRequestByIdQuery } from "@src/services/slices/projectRoleRequestsApi";
import { AlertConfig } from "@src/types";
import { getRoleRequestAlertConfigs } from "@src/utils/notification_utils";

interface RoleRequestNotificationBarProps {
  requestId: number;
}

const RoleRequestNotificationBar: React.FC<RoleRequestNotificationBarProps> = ({
  requestId,
}) => {
  const { data: request } = useGetRoleRequestByIdQuery(requestId, {
    skip: !requestId,
  });

  const alertConfigs: AlertConfig[] = getRoleRequestAlertConfigs(request);

  return (
    <div style={{ width: "100%" }}>
      {alertConfigs
        .filter((alert: AlertConfig) => alert?.condition)
        .map((shownAlert: AlertConfig) => (
          <NotificationBanner
            type={shownAlert.type}
            message={shownAlert.message}
          />
        ))}
    </div>
  );
};

export default RoleRequestNotificationBar;
